import React from 'react';
import { Button } from '@mui/material';

/**
 * Check if a batch API response indicates a background task was started (HTTP 202).
 */
export function isBackgroundTaskResponse(res) {
    return res && res.statusCode === 202 && res.data && res.data.task_id;
}

/**
 * Show a notistack toast for a background task with a clickable "View" action
 * that opens the full-screen dialog and expands the task's detail panel.
 *
 * Usage:
 *   if (isBackgroundTaskResponse(res)) {
 *       notifyBackgroundTask(res, enqueueSnackbar, closeSnackbar, bgCtx);
 *       return;
 *   }
 */
export function notifyBackgroundTask(res, enqueueSnackbar, closeSnackbar, bgCtx) {
    const label = res.data.task_label || 'Operation';
    const taskId = res.data.task_id;
    enqueueSnackbar(`${label} started in background`, {
        variant: 'info',
        action: (key) => (
            <Button
                color="inherit"
                size="small"
                onClick={() => {
                    closeSnackbar(key);
                    if (bgCtx && bgCtx.openDialogForTask) {
                        bgCtx.openDialogForTask(taskId);
                    }
                }}
            >
                View
            </Button>
        ),
    });
}
